<div class="fs-small">{{ label }}</div>
<div class="wrapper">
  <mat-form-field class="compact no-error mr-10">
    <input matInput readonly [value]="copyContent">
  </mat-form-field>

  <button [appCopyToClipboard]="copyContent" class="btn copy-button basic icon-copy">Copy</button>
</div>
